import {eventHandler, find, listener} from "../../../../modules/vegas/js/util";
import axios from "axios";

listener('submit', '#form-register-company', (form, e) => {
	let msgError = form.querySelector('.msg-error');

	let btn = form.querySelector('button[type=submit]');
	btn.disabled = true;

	axios.post(form.action, new FormData(form))
		.then((response) => {
			msgError.innerText = response.data.msg || '';
			msgError.classList.toggle('d-none', !response.data.error);

			if (!response.data.error && response.data.redirect_to) {
				location.href = response.data.redirect_to;
			}

			if (!response.data.error && response.data.need_code) {
				form.querySelector('#email-code').classList.remove('d-none');
				form.querySelector('#email-code input').required = true;

				form.querySelector('#data-org').classList.add('d-none');
				form.querySelector('#data-person').classList.add('d-none');
			}

			btn.disabled = false;
		})
		.catch((error) => {
			msgError.innerText = error.response.data.message || "Произошла неизвестная ошибка";
			msgError.classList.remove('d-none');

			btn.disabled = false;
		});
}, true);

listener('change', '#form-register-company #company_inn', (input, e) => {
	axios.get('/companies/get_by_inn', {
		params: {
			inn: input.value,
		}
	}).then(response => {
		if (response.data.info) {
			let form = input.closest('form');

			for(let key in response.data.info) {
				let value = response.data.info[key];

				[...form.querySelectorAll(`[data-autocomplete="${key}"]`)].forEach(el => {
					el.value = value;
				});
			}
		}
	});
});
